import React from "react";
import PrintManager from "./printManager";

class PrintStatusWidget extends React.Component {
    state = {
        total: 0,
        completed: 0,
        active: 0
    };

    componentDidMount() {
        this.unsubscribe = PrintManager.subscribe(state => {
            this.setState(state);
        });
    }

    componentWillUnmount() {
        this.unsubscribe();
    }

    render() {

        const { total, completed, active } = this.state;

        if (total === 0 || completed === total) return null;

        return (
            <div style={{
                position: "fixed",
                bottom: 20,
                right: 20,
                background: "#1e293b",
                color: "white",
                padding: "12px 18px",
                borderRadius: 12,
                boxShadow: "0 8px 20px rgba(0,0,0,0.3)",
                zIndex: 9999,
                fontSize: 14
            }}>
                Imprimiendo {completed + active}/{total}
                <br />
                Activos: {active}
            </div>
        );
    }
}

export default PrintStatusWidget;